import React from 'react';
import MyAppText from './MyAppText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translate } from '../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import moment from 'moment';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition as FreeIconDefinition } from '@fortawesome/free-regular-svg-icons';
import { StyleProp, TextStyle } from 'react-native';

interface InfoInRowParams {
    title?: string;
    titleSuffix?: string;
    value: string | boolean | number | null | undefined;
    isDate?: boolean;
    fontAwesomeIcon?: IconDefinition;
    valueStyle?: StyleProp<TextStyle>;
}

export function InfoInRow({ title = '', titleSuffix = '', value, isDate, fontAwesomeIcon, valueStyle }: InfoInRowParams) {
    const { styles, theme } = useStyles(styleSheet);

    if (value === '' || value == null || value == undefined) {
        return;
    }

    const renderLabel = () => (
        <MyAppText style={{ fontWeight: 'bold' }}>
            {fontAwesomeIcon ? (
                <FontAwesomeIcon icon={fontAwesomeIcon as FreeIconDefinition} fontSize={16} style={{ width: 16 }} color={theme.colors.iconColor} />
            ) : (
                `${translate(title)}${titleSuffix ? ` ${titleSuffix}` : ''}:`
            )}
        </MyAppText>
    );

    const renderValue = (val: string | number | boolean) => (
        <MyAppText style={valueStyle}>{val}</MyAppText>
    );

    if (typeof value === 'boolean') {
        return (
            <MyAppText style={styles.detectionInfoText}>
                {renderLabel()} {renderValue(translate(value ? 'yes' : 'no'))}
            </MyAppText>
        );
    } else if (isDate) {
        return (
            <MyAppText style={styles.detectionInfoText}>
                {renderLabel()} {renderValue(moment(value).format('DD/MM/YYYY HH:mm'))}
            </MyAppText>
        );
    }

    return (
        <MyAppText style={styles.detectionInfoText}>
            {renderLabel()} {renderValue(value)}
        </MyAppText>
    );

}


const styleSheet = createStyleSheet(theme => ({
    detectionInfoText: {
        color: theme.colors.labelColor,
        fontSize: 12
    }
}));
